/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const PictureInPictureEnterIcon = ({ width = 20, height = 18, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 20 18' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M11.5 10.8C11.5 10.3582 11.8582 9.99999 12.3 9.99999H16.1737C16.6155 9.99999 16.9737 10.3582 16.9737 10.8V14.1412C16.9737 14.583 16.6155 14.9412 16.1737 14.9412H12.3C11.8582 14.9412 11.5 14.583 11.5 14.1412V10.8Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 16.2V1.80016C0 0.806054 0.805875 0.000168085 1.79998 0.000158489L18.2 0C19.1941 -9.65587e-06 20 0.805881 20 1.8V16.2C20 17.1941 19.1941 18 18.2 18H1.8C0.805886 18 0 17.1941 0 16.2ZM1 1.80016V16.2C1 16.6418 1.35817 17 1.8 17H18.2C18.6418 17 19 16.6418 19 16.2V1.8C19 1.35817 18.6418 0.999996 18.2 1L1.79999 1.00016C1.35817 1.00016 1 1.35833 1 1.80016Z'
    />
  </svg>
);

export default PictureInPictureEnterIcon;
